import { render } from "./EmptyRouter.vue?vue&type=template&id=36373094&ts=true"
import script from "./EmptyRouter.vue?vue&type=script&lang=ts"
export * from "./EmptyRouter.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__